define(function(require, exports, module) {
	var toolkit = require('toolkit/b-toolkit/b-toolkit');
	var BToolkit = toolkit['b-toolkit'];

	var BDeepLinkBanner = toolkit.create('b-deeplink-banner', {
		init: function() {
			BToolkit.fn.init.apply(this, arguments);

		}
	});

	module.exports = BDeepLinkBanner;
});

